import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RaceDetailsComponent } from './components/betting/race-details/race-details.component';
import { ResultDetailsComponent } from './components/betting/result-details/result-details.component'
import { BrowserModule } from '@angular/platform-browser';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'news',
    loadChildren: () => import('./pages/news/news.module').then(m => m.NewsPageModule)
  },
  {
    path: 'results',
    loadChildren: () => import('./pages/results/results.module').then(m => m.ResultsPageModule)
  },
  {
    path: 'book-of-rules',
    loadChildren: () => import('./pages/book-of-rules/book-of-rules.module').then(m => m.BookOfRulesPageModule)
  },
  {
    path: 'about-us',
    loadChildren: () => import('./pages/about-us/about-us.module').then(m => m.AboutUsPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/my-account/my-account.module').then(m => m.MyAccountPageModule)
  },
  {
    path: 'racing-paper',
    loadChildren: () => import('./pages/racing-paper/racing-paper.module').then(m => m.RacingPaperPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./modals/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'registration',
    loadChildren: () => import('./modals/registration/registration.component').then(m => m.RegistrationComponent)
  },
  {
    path: 'race_details',
    component: RaceDetailsComponent
  },

  {
    path: 'results_details',
    component: ResultDetailsComponent
  },
  {
    path: 'confirmRegistration',
    loadChildren: () => import('./pages/confirm-registration/confirm-registration.module').then( m => m.ConfirmRegistrationPageModule)
  },
  {
    path: 'casino_login',
    loadChildren: () => import('./pages/casino-login/casino-login.module').then(m => m.CasinoLoginPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }), BrowserModule
  ],
  exports: [RouterModule, BrowserModule]
})
export class AppRoutingModule { }
